import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const FAQItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-100 py-4 sm:py-5 md:py-6" data-id="element-412">
      <button className="flex justify-between items-start w-full text-left group min-h-[44px]" onClick={() => setIsOpen(!isOpen)} data-id="element-413">
        <h3 className="text-base sm:text-lg md:text-xl font-medium text-gray-900 group-hover:text-orange-600 transition-colors pr-4 flex-1" data-id="element-414">
          {question}
        </h3>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="flex-shrink-0 mt-1" data-id="element-415">
          <ChevronDownIcon size={20} className="text-gray-400" data-id="element-416" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-417">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-418">
            <p className="text-gray-600 mt-3 sm:mt-4 text-base sm:text-lg leading-relaxed" data-id="element-419">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
const FAQ = () => {
  const faqs = [{
    question: 'What is FluidWeb?',
    answer: 'FluidWeb is an agentic interface runtime: in-product AI execution surfaces (forms, navigation, data explorer, actions) powered by a policy + orchestration platform with auditability and safe controls.'
  }, {
    question: 'How is this different from a chatbot?',
    answer: 'Chatbots answer. FluidWeb executes inside your product UI — with schema validation, permissions, approvals, and audit/replay built in.'
  }, {
    question: 'What autonomy levels are available?',
    answer: 'Assist (locked), Execute (supervised with approvals), and Autopilot (bounded execution under strict policy).'
  }, {
    question: 'Can I use my own UI components?',
    answer: "Yes. Use FluidWeb's drop-in interfaces or build custom surfaces that plug into the same policy + execution layer."
  }, {
    question: 'What about security and compliance?',
    answer: 'FluidWeb includes RBAC, encryption, audit logs, and SSO/SAML support, with SOC 2 Type II in progress.'
  }, {
    question: 'Why buy instead of building it in-house?',
    answer: 'To ship production-safe in-product AI, teams typically need to build and maintain streaming contracts, tool execution controls, approval flows, audit/replay, evals, regression gates, and multi-tenant governance. FluidWeb provides that platform layer so product teams can ship workflows in weeks, not quarters.'
  }, {
    question: 'How do we get started?',
    answer: "Start in Assist mode with one workflow (e.g., vendor onboarding). Connect tools, define policies, and expand autonomy only after you've proven safety with logs + replay."
  }];
  return <section className="w-full bg-white py-16 sm:py-24 md:py-32 lg:py-48" id="faq" data-id="element-420">
      <div className="container mx-auto px-4 sm:px-6 md:px-8" data-id="element-421">
        <div className="max-w-3xl mx-auto" data-id="element-422">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8 sm:mb-10 md:mb-12" data-id="element-423">
            Questions
          </h2>
          <div className="space-y-1 sm:space-y-2" data-id="element-424">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-425" />)}
          </div>
        </div>
      </div>
    </section>;
};
export default FAQ;